
import { isAllowedChannel } from '@/common/helpers/ModuleHelpers';
import { createNamespacedHelpers } from '@/common/vuex-composition-hooks';
import { IAuthActions, IAuthGetters, IAuthState } from '@/modules/login/types';
import router from '@/router';
import { ROUTE_NAMES } from '@/router/routes';
import { defineComponent, onMounted, reactive, toRefs } from 'vue';
import * as vueRouter from 'vue-router';
const { useActions } = createNamespacedHelpers<
  IAuthState,
  IAuthGetters,
  IAuthActions
>('auth');

interface ITab {
  id: number;
  name?: string;
  active?: boolean;
  route?: string;
  codeChannel: number;
}

interface State {
  tabs: ITab[];
  tabActive: any;
  allowedTabs: any;
}

export default defineComponent({
  name: 'Tabs',

  setup() {
    const { setNextBillingUnit } = useActions(['setNextBillingUnit']);

    const state: State = reactive<State>({
      tabs: [
        {
          id: 1,
          name: 'Wholesale',
          active: false,
          route: ROUTE_NAMES.WHOLESALEDESK,
          codeChannel: 0,
        },
        {
          id: 2,
          name: 'DTC',
          active: false,
          route: ROUTE_NAMES.DTCDESK,
          codeChannel: 10,
        },
        {
          id: 3,
          name: 'Exportação',
          active: false,
          route: ROUTE_NAMES.EXPORTDESK,
          codeChannel: 3,
        },
        {
          id: 4,
          name: 'ECOMM',
          active: false,
          route: ROUTE_NAMES.ECOMMERCEDESK,
          codeChannel: 1,
        },
      ],
      tabActive: '',
      allowedTabs: [],
    });

    const isActiveTab = (pTabs) => {
      const route = vueRouter.useRoute();
      return pTabs.codeChannel === route.meta.codeChannel;
    };

    state.allowedTabs = state.tabs.filter((tab: ITab) =>
      isAllowedChannel(tab.codeChannel)
    );

    const handleTabChange = async (tabIndex: number) => {
      state.allowedTabs.forEach((tab: ITab) => {
        tab.active = false;
      });

      const tab = state.allowedTabs[tabIndex];

      state.tabActive = tab;

      if (tab) tab.active = true;

      if (tabIndex === 0) await setNextBillingUnit();

      await router.push({ name: tab?.route });
    };

    const init = async () => {
      const route = vueRouter.useRoute();
      state.tabActive = route.meta.codeChannel;

      const tab = state.allowedTabs.find(
        (tab: ITab) => tab.codeChannel === state.tabActive
      );

      if (tab) {
        tab.active = true;
        state.tabActive = tab;
      } else {
        const tabActive = state.allowedTabs[0];
        if (tabActive) {
          state.tabActive = tabActive;
          tabActive.active = true;
        }
      }
    };

    onMounted(init);
    return {
      ...toRefs(state),
      isActiveTab,
      handleTabChange,
      isAllowedChannel,
    };
  },
});
